<template>
  <div class="nettdoc-rash-itch-redness">
    <SectionHeader 
      text="I do have a rash/ itch/ redness" 
      img="illu-card-beschwerden-rash" 
      alt="rash hand" 
      :collapsable="true" 
      v-on:collapse="collapsed = !collapsed"
      :complete="store.rashItchRednessDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader text="Which disorder do you suffer?" :dark="true" :required="true" />
      <CheckboxList 
        :data="['Rash', 'Itchiness', 'Redness']"
        :choice="store.rashItchRednessDetails.type"
        v-on:action="value => store.addRashItchRednessDetails('type', value, true)"          
      />

      <SectionHeader text="Which parts of the body are affected?" :dark="true" :required="true" />
      <Bodyparts 
        :model="store.rashItchRednessDetails.location"
        v-on:action="value => store.addRashItchRednessDetails('location', value)"
      />

      <SectionHeader text="Since when do you have the symptoms?" :dark="true" :required="true" />
      <Dropdown
        label="please choose"
        :data="['A few hours', '1 day', '2 to 6 days', 'More than one week', '1 Month']"
        :choice="store.rashItchRednessDetails.since"
        v-on:action="value => store.addRashItchRednessDetails('since', value)"
      />

      <SectionHeader text="behavior" :dark="true" :required="true" />
      <CheckboxList 
        :data="['...is getting bigger', '...does not get bigger', '...becomes less', '...is changing it\'s location']"
        :choice="store.rashItchRednessDetails.behavior"
        v-on:action="value => store.addRashItchRednessDetails('behavior', value, true)"          
      />

      <SectionHeader text="skinMoistens" :dark="true" :required="false" />
      <YesNo
        :model="store.rashItchRednessDetails.skinMoistens"
        v-on:action="value => store.addRashItchRednessDetails('skinMoistens', value)"
      />

      <SectionHeader text="skinScalesOff" :dark="true" :required="false" />
      <YesNo
        :model="store.rashItchRednessDetails.skinScalesOff"
        v-on:action="value => store.addRashItchRednessDetails('skinScalesOff', value)"
      />

      <SectionHeader text="skinUlcerate" :dark="true" :required="false" />
      <TripleChoice
        :model="store.rashItchRednessDetails.skinUlcerate"
        v-on:action="value => store.addRashItchRednessDetails('skinUlcerate', value)"
      />

      <SectionHeader text="skinIsSwollen" :dark="true" :required="false" />
      <YesNo
        :model="store.rashItchRednessDetails.skinIsSwollen"
        v-on:action="value => store.addRashItchRednessDetails('skinIsSwollen', value)"
      />

      <SectionHeader text="contactWithSkinDiseasePeople" :dark="true" :required="true" />
      <TripleChoice
        :model="store.rashItchRednessDetails.contactWithSkinDiseasePeople"
        v-on:action="value => store.addRashItchRednessDetails('contactWithSkinDiseasePeople', value)"
      />

      <SectionHeader text="contactWithToxicMaterial" :dark="true" :required="true" />
      <TripleChoice
        :model="store.rashItchRednessDetails.contactWithToxicMaterial"
        v-on:action="value => store.addRashItchRednessDetails('contactWithToxicMaterial', value)"
      />

      <SectionHeader text="stungByInsect" :dark="true" :required="true" />
      <TripleChoice
        :model="store.rashItchRednessDetails.stungByInsect"
        v-on:action="value => store.addRashItchRednessDetails('stungByInsect', value)"
      />

      <SectionHeader text="injury" :dark="true" :required="false" />
      <YesNo
        :model="store.rashItchRednessDetails.injury"
        v-on:action="value => store.addRashItchRednessDetails('injury', value)"
      />

      <template v-if="store.rashItchRednessDetails.injury === 'yes'">
        <SectionHeader text="injuryLocation" :dark="true" :required="false" />
        <Bodyparts 
          :model="store.rashItchRednessDetails.injuryLocation"
          v-on:action="value => store.addRashItchRednessDetails('injuryLocation', value)"
        />
      </template>

      <SectionHeader text="allergic" :dark="true" :required="false" />
      <TripleChoice
        :model="store.rashItchRednessDetails.allergic"
        v-on:action="value => store.addRashItchRednessDetails('allergic', value)"
      />

      <SectionHeader text="diagnosedSkinDisease" :dark="true" :required="false" />
      <TripleChoice
        :model="store.rashItchRednessDetails.diagnosedSkinDisease"
        v-on:action="value => store.addRashItchRednessDetails('diagnosedSkinDisease', value)"
      />

      <SectionHeader text="diagnosedSkinDiseaseInFamily" :dark="true" :required="false" />
      <TripleChoice
        :model="store.rashItchRednessDetails.diagnosedSkinDiseaseInFamily"
        v-on:action="value => store.addRashItchRednessDetails('diagnosedSkinDiseaseInFamily', value)"
      />

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.rashItchRednessDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader";
import YesNo from "../YesNo";
import Button from "../Button";
import Dropdown from "../Dropdown";
import Bodyparts from '../Bodyparts'
import CheckboxList from '../CheckboxList'
import TripleChoice from '../TripleChoice'
export default observer({
  name: "RashItchRedness",
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, Dropdown, Bodyparts, CheckboxList, TripleChoice
  },
  methods: {
    submit: function() {
      this.store.rashItchRednessDetails.submitted = true
      localStorage.setItem(
        "rashItchRednessDetails",
        JSON.stringify(this.store.rashItchRednessDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>

</style>